var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "-2 -1 24 24",
    enableBackground: "new -2 -1 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.108,13.212c-0.822-0.936-1.807-1.748-2.897-2.362c1.33-1.129,2.177-2.811,2.177-4.693C16.388,2.756,13.632,0,10.23,0 c-3.4,0-6.156,2.756-6.156,6.157c0,1.794,0.771,3.403,1.994,4.528c-1.205,0.627-2.283,1.51-3.177,2.526 c-1.789,2.036-2.969,4.757-2.969,7.474V22h20.154v-1.314C20.077,17.969,18.897,15.248,17.108,13.212z M10.23,2.629 c1.95,0,3.528,1.579,3.528,3.528s-1.578,3.528-3.528,3.528c-1.948,0-3.527-1.579-3.527-3.528S8.282,2.629,10.23,2.629z M2.675,19.37 c0.288-1.573,1.071-3.147,2.191-4.423c1.436-1.633,3.291-2.634,5.134-2.634c1.842,0,3.698,1.001,5.134,2.634 c1.12,1.275,1.902,2.85,2.191,4.423H2.675z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.487341c59d2b75e7f7044f5cd0ce94c1.svg";
export { ForwardRef as ReactComponent };